export default function StatsCard({ title, value, color = "#60a5fa" }) {
  return (
    <div className="stat-card">
      <div className="stat-label">{title}</div>
      <div className="stat-value" style={{ color }}>
        {value}
      </div>
    </div>
  );
}